import { Component, Inject } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select } from '@ngxs/store';
import { CreateStatusType } from '@state/utils/models';
import { Observable } from 'rxjs';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatterDispatch } from '@state/matter';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { Brokerage } from '@models/matter';

@UntilDestroy()
@Component({
	selector: 'app-create-brokerage',
	templateUrl: './create.component.html',
	standalone: false,
})
export class CreateBrokerageComponent {
	public name;
	public isClient;
	public createStatusType = CreateStatusType;
	public brokerage: Brokerage;

	@SelectSnapshot(SelectedMatter.id) saleId;
	@SelectSnapshot(SelectedMatter.matterFileType) matterFileType;

	constructor(
		public dialogRef: MatDialogRef<CreateBrokerageComponent>,
		// rome-ignore lint/suspicious/noExplicitAny: <explanation>
		@Inject(MAT_DIALOG_DATA) public data: any,
		private matterDispatch: MatterDispatch,
	) {
		this.name = data.name;
		this.isClient = data.isClient;
		this.brokerage = data.brokerage;
	}

	createBrokerage = (brokerage: Brokerage) =>
		this.matterDispatch.CreateBrokerage(
			this.saleId,
			brokerage,
			this.isClient,
			this.matterFileType,
		);

	onSubmit(event) {
		this.createBrokerage(event);
		this.dialogRef.close(event.id);
	}
}

export interface CreateOrUpdateBrokerageModel {
	name: string;
	isClient: boolean;
	brokerage: Brokerage;
}
